import * as React from "react";
import { isAdmin } from "../../utils/utils";
import styles from "./SideMenu.module.scss";
import SidemenuLink from "../../components/SidemenuLink/SidemenuLink";
import { withRouter, RouteComponentProps } from "react-router-dom";
import home from "../../images/ico-home.svg";
import elevator from "../../images/ico-elevator.svg";
import drive from "../../images/ico-drive.svg";
import group from "../../images/ico-group.svg";
import apm from "../../images/ico-apm.svg";
import lio from "../../images/ico-lio.svg";
import safety from "../../images/ico-safety.svg";
import escalator from "../../images/ico-escalator.svg";
import door from "../../images/ico-door.svg";
import signalization from "../../images/ico-signalization.svg";
import site from "../../images/ico-site.svg";
import localization from "../../images/ico-localization.svg";
import users from "../../images/ico-users.svg";
import enumerations from "../../images/ico-enumerations.svg";
import tools from "../../images/ico-tools.svg";
import network from "../../images/ico-network.svg";
import monitoring from "../../images/ico-monitoring.svg";

export type SideMenuProps = {
  activeSubmenu: State.Submenu;
  activeUser: Api.User | undefined;
  handleNavLinkOnClick: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface PathProps {
  /*  */
}

class SideMenu extends React.PureComponent<SideMenuProps & RouteComponentProps<PathProps>> {
  render() {
    const { activeUser, handleNavLinkOnClick } = this.props;
    return (
      <div className={`${styles.sideMenuContainer} sideMenuContainer`}>
        <SidemenuLink
          key={"Home"}
          to={"/home/"}
          name={"Home"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={home}
        />
        <SidemenuLink
          key={"Elevator"}
          to={"/elevator"}
          name={"Elevator"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={elevator}
        />

        <SidemenuLink
          key={"Drive"}
          to={"/drive"}
          name={"Drive"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={drive}
        />
        <SidemenuLink
          key={"Group"}
          to={"/group"}
          name={"Group"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={group}
        />
        <SidemenuLink
          key={"LIO"}
          to={"/lio"}
          name={"LIO"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={lio}
        />
        <SidemenuLink
          key={"APM"}
          to={"/apm"}
          name={"APM"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={apm}
        />
        <SidemenuLink
          key={"Safety"}
          to={"/safety"}
          name={"Safety"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={safety}
        />
        <SidemenuLink
          key={"Escalator"}
          to={"/escalator"}
          name={"Escalator"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={escalator}
        />
        <SidemenuLink
          key={"Door"}
          to={"/door"}
          name={"Door"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={door}
        />
        <SidemenuLink
          key={"Network"}
          to={"/network"}
          name={"Network"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={network}
        />
        <SidemenuLink
          key={"Monitoring"}
          to={"/monitoring"}
          name={"Monitoring"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={monitoring}
        />

        <SidemenuLink
          key={"NonKone"}
          to={"/nonkone"}
          name={"Non-Kone"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={elevator}
        />
        <SidemenuLink
          key={"Signalization"}
          to={"/signalization"}
          name={"Signalization"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={signalization}
        />
        <SidemenuLink
          key={"Site"}
          to={"/site"}
          name={"Site"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={site}
        />
        <SidemenuLink
          key={"Localization"}
          to={"/localization"}
          name={"Localization"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={localization}
        />

        {isAdmin(activeUser) && (
          <SidemenuLink
            key={"Users"}
            to={"/users/"}
            name={"Users"}
            handleOnClick={handleNavLinkOnClick}
            imgSrc={users}
          />
        )}
        <SidemenuLink
          key={"Enumerations"}
          to={"/enumerations"}
          name={"Enumerations"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={enumerations}
        />
        <SidemenuLink
          key={"Tools"}
          to={"/tools"}
          name={"Tools"}
          handleOnClick={handleNavLinkOnClick}
          imgSrc={tools}
        />
      </div>
    );
  }
}

export default withRouter(SideMenu);

